import { render, staticRenderFns } from "./HomeIntro.vue?vue&type=template&id=937c8db4&"
import script from "./HomeIntro.tsx?vue&type=script&lang=ts&"
export * from "./HomeIntro.tsx?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports